import { LabelOption } from 'echarts/types/src/util/types';
import { fieldId } from '../../field-id.model';

export enum LabelPosition {
  Top = 'top',
  Left = 'left',
  Bottom = 'bottom',
  Inside = 'inside',
  InsideTop = 'insideTop',
  InsideLeft = 'insideLeft',
  InsideRight = 'insideRight',
  InsideBottom = 'insideBottom',
  InsideTopLeft = 'insideTopLeft',
  InsideTopRight = 'insideTopRight',
  InsideBottomLeft = 'insideBottomLeft',
  InsideBottomRight = 'insideBottomRight',
}

export class LabelModel {
  constructor(
    public show = true,
    public field_ids: fieldId[] = [],
    public rotate = 0, // -90 - + 90
    public align: 'left' | 'right' | 'center' = 'center',
    public verticalAlign: 'top' | 'middle' | 'bottom' = 'top',
    public offset?: number[], // [x: -100 - 100, y: -100 - 100]
    public position?: LabelPosition,
    public quillString?: string,
    public rich?: LabelOption['rich'],
    public formatter?: (params: { data: Record<string, number> }) => string,
    public isCustomQuillString = false,
  ) {}
}

export type LabelSetting =
  | 'labelPosition'
  | 'horizontalAlign'
  | 'verticalAlign'
  | 'rotate'
  | 'horizontalOffset'
  | 'verticalOffset'
  | 'labelLine';
